/**
 * The narrowing every `unknown` wire payload starts from (plan §2.2.2 · AD-10).
 *
 * `typeof null === 'object'`, so the null check is not optional decoration —
 * without it a `null` body would satisfy the guard and every property read
 * downstream would throw. Arrays pass deliberately: an array IS an object for
 * indexed access, and the callers that care assert their own shape after.
 *
 * This lives in its own module for the same reason `read-optional-json.ts`
 * does — it is imported by both `auth-context.tsx` and `passkey-login.tsx`,
 * and depending on nothing keeps it importable from either without closing a
 * cycle (`no-circular` is an error, not a warning — .dependency-cruiser.cjs).
 */

/** True for any non-null object, so callers may index it without a cast. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
